export default {
	sec_01: {
		title: {
			one: 'お客様の気持ちや',
			two: '消費者の',
			three: '為の',
			four: 'もの',
		},
		desc: {
			one: '機械学習を通じてビジネスを守り、',
			two: 'お客様の資産と共に消費者の事をお守りする事が出来ます。',
		},
	},
	sec_14: {
		desc: {
			one: 'あなたのビジネスに高度にカスタマイズ可能な商取引ソリューションが必要ですか？',
		},
		btn: '企業向けのJPWORLDPAYについて学ぶ。',
	},
	sec_03: {
		title: {
			one: '豊かな経験',
		},
		desc: {
			one: 'ブロックチェーンが知られるようになり始めてから積み重ねたブロックチェーン',
			two: 'ノウハウを基に作られたJPWORLDPAYを通じて安全な取引をご利用ください。',
		},
		one: {
			title: {
				one: '安全な取引',
			},
			desc: {
				one: '世界で最も安全なブロックチェーンに基づいて、',
				two: '世界中の顧客に近づくことができます。',
			},
		},
		two: {
			title: {
				one: '詐欺探知技術',
			},
			desc: {
				one: '当社の詐欺探知ツールは、取引があるたびにより知能化し、',
				two: '既存の脅威だけではなく進化する脅威までもあなたをお守り致します。',
			},
		},
	},
};
